import { render } from "./AssistantDetail.vue?vue&type=template&id=58115bd5&scoped=true"
import script from "./AssistantDetail.vue?vue&type=script&lang=js"
export * from "./AssistantDetail.vue?vue&type=script&lang=js"

import "./AssistantDetail.vue?vue&type=style&index=0&id=58115bd5&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58115bd5"]])

export default __exports__